<template>
    <div>
        <div class="leaves_top"></div>

        <HeaderMenu_Site />
        <LateralMenu_Site />

        <div id="login">
            <div class="content">
                <div class="lockquest-form">
                    <div class="column left">
                        <div>
                            <span>Administration Lock Quest</span>
                            <div class="multiple">
                                <div>
                                    <span>Nom d'utilisateur *</span>
                                    <input type="text" v-model="formLogin_email" v-bind:class="formLogin_bindClass(formLogin_email)" />
                                </div>
                                <div>
                                    <span>Mot de passe *</span>
                                    <input type="password" v-model="formLogin_password" v-bind:class="formLogin_bindClass(formLogin_password)" />
                                </div>
                            </div>

                            <div class="button-container">
                                <button v-on:click="connexion_buttonClicked" v-bind:disabled="isLoading">Connexion</button>
                                <span class="form-error">{{ formLogin_error }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="leaves_sides">
            <div class="left"></div>
            <div class="right"></div>
        </div>

        <Footer />
    </div>
</template>

<script>
import HeaderMenu_Site from '../../components/HeaderMenu_Site.vue';
import LateralMenu_Site from '../../components/LateralMenu_Site.vue';
import Footer from '../../components/Footer.vue';

export default {
    name: "Admin_LoginPage",
    components: {
        HeaderMenu_Site,
        LateralMenu_Site,
        Footer
    },
    data: () => ({
        isLoading: false,
        // form parameters
        formLogin_isSubmit: false,
        formLogin_email: null,
        formLogin_password: null,
        formLogin_error: null
    }),
    methods: {
        connexion_buttonClicked: function(event) {
            this.formLogin_isSubmit = true;

            if (!this.formLogin_email || !this.formLogin_password) {
                this.formLogin_bindClass(this.formLogin_email);
                this.formLogin_bindClass(this.formLogin_password);
                this.formLogin_error = 'Veuillez remplir les champs indiqués en rouge et essayez à nouveau';

                this.isLoading = false;
            } else {
                this.formLogin_error = null;
                this.isLoading = true;

                this.$store.dispatch('authentication/requestToken', {
                    email: this.formLogin_email,
                    password: this.formLogin_password
                }).then(() => {
                    this.isLoading = false;
                    this.$router.push({ name: 'admin_reservationspage' }).catch((error) => { });
                }).catch((error) => {
                    switch(error) {
                        case 'ACCOUNT_NOT_FOUND':
                            this.formLogin_error = 'Cette adresse e-mail est introuvable';
                            break;
                        case 'WRONG_PASSWORD':
                            this.formLogin_error = 'Le mot de passe semble être erroné, merci de ré-essayer';
                            break;
                        default :
                            this.formLogin_error = 'Une erreur interne est survenue, veuillez contacter l\'administrateur';
                            break;
                    }
                });

                this.isLoading = false;
            }
        },
        formLogin_bindClass: function(form_dataField) {
            return { 'has-error': this.formLogin_isSubmit && (!form_dataField || form_dataField == '') };
        }
    }
}
</script>